import { WasmHandler } from "react-lib/frameworks/WasmController";

// APIs
import DentalExaminationFormDetail from "issara-sdk/apis/DentalExaminationFormDetail_apps_DEN";
import DentalExaminationFormList from "issara-sdk/apis/DentalExaminationFormList_apps_DEN";
import PatientSupernumeraryToothList from "issara-sdk/apis/PatientSupernumeraryToothList_apps_DEN";
import PeriodontiumRecordDetail from "issara-sdk/apis/PeriodontiumRecordDetail_apps_DEN";
import PeriodontiumRecordList from "issara-sdk/apis/PeriodontiumRecordList_apps_DEN";

export type State = {
  encounterInfo?: any;
  historyPeriodontiumRecord?: {
    id: number;
    encounter: number;
    bleeding_index: string;
    plaque_index: string;
    data: any;
  };

  historyVisitPeriodontiumRecord?: {
    id: number;
    encounter: number;
    bleeding_index: string;
    plaque_index: string;
    data: any;
  };

  historyTreatmentPeriodontiumRecord?: {
    id: number;
    encounter: number;
    bleeding_index: string;
    plaque_index: string;
    data: any;
  };

  periodontiumRecord?: {
    id: number;
    encounter: number;
    bleeding_index: string;
    plaque_index: string;
    data: any;
    tmp_plaque?: string[];
    tmp_bleeding?: string[];
    editing_plaque?: boolean;
    editing_bleeding?: boolean;
    editing_psr?: string;
  };
  periodontiumHistoryList: any[];
  periodontalExamData: {
    data: any;
  };
  // missingteeth: any[];
};

export const StateInitial = {
  encounterInfo: {},
  historyPeriodontiumRecord: {
    id: null,
    encounter: null,
    bleeding_index: "0.00",
    plaque_index: "0.00",
    data: {},
  },
  historyVisitPeriodontiumRecord: {
    id: null,
    encounter: null,
    bleeding_index: "0.00",
    plaque_index: "0.00",
    data: {},
  },
  historyTreatmentPeriodontiumRecord: {
    id: null,
    encounter: null,
    bleeding_index: "0.00",
    plaque_index: "0.00",
    data: {},
  },
  periodontiumRecord: {
    id: null,
    encounter: null,
    bleeding_index: "0.00",
    plaque_index: "0.00",
    data: {},
  },
  periodontiumHistoryList: [],
  periodontalExamData: {
    data: {},
  },
  // missingteeth: [],
};

export type Event =
  | { message: "handleGetMissingTooth" }
  | { message: "GetPeriodontium"; params?: { history?: boolean; encounterId: number; visit?: boolean; treatment?: boolean; } }
  | { message: "handleChangePeriodontiumRecordData"; params: { name: string; value: string } }
  | { message: "handleSavePeriodontiumRecordData" }
  | { message: "SetPlaque"; params: { key: string } }
  | { message: "SetBleeding"; params: { key: string } }
  | { message: "RecalPlaqueBleed"; params: {} }
  | { message: "CalculatePlaqueIndex"; params: any }
  | { message: "CalculateBleedingIndex"; params: any }
  // History
  | { message: "handleGetPeriodontiumHistory" }
  // Examination
  | { message: "SetCheckedPeriodontalExam"; params: {} }
  | { message: "handleGetPeriodontalExam" }
  | { message: "handleSavePeriodontalExam" };

type Handler = WasmHandler<State, Event>;

const TISSUE_NAME = "Periodontium";
// GET
export const handleGetMissingTooth: Handler = async (controller) => {
  controller.setState({ isMainLoading: true });

  const state = controller.getState();

  const params = { patient: state.patientDetail.id, status: "MISSING" };
  const response = await GetMissingTooth(controller, params);

  controller.setState({ isMainLoading: false, missingteeth: response });
};

export const GetPeriodontium: Handler = async (controller, params) => {
  console.log("GetPeriodontium")
  // controller.setState({ isMainLoading: true });

  const state = controller.getState();
  let paramsAPI;
  if ((params?.visit || params?.treatment || params?.history) && params?.encounterId) {
    paramsAPI = { encounter: params?.encounterId };
  } else {
    paramsAPI = { encounter: state.encounterInfo.id };
  }

  const response = await GetPeriodontiumRecord(controller, paramsAPI);
  let data: StateInitial.periodontiumRecord = { ...StateInitial.periodontiumRecord, encounter: state.encounterInfo.id };
  if (response.length > 0) {
    Object.keys(StateInitial.periodontiumRecord).forEach((key) => {
      data[key] = response[0][key];
    });
  }

  data.tmp_plaque = data?.data?.plaque
  data.tmp_bleeding = data?.data?.bleeding

  if (params?.visit && params?.encounterId && params.card !== "PTM") {
    controller.setState({
      isMainLoading: false,
      historyVisitPeriodontiumRecord: data,
    });
  } else if (params?.visit && params?.encounterId && params.card === "PTM") {
    controller.setState({
      isMainLoading: false,
      periodontiumRecord: data,
    });
  } else if (params?.history && params?.encounterId) {
    controller.setState({
      isMainLoading: false,
      historyPeriodontiumRecord: data,
    });
  } else if (params?.treatment && params?.encounterId) {
    controller.setState({
      isMainLoading: false,
      historyTreatmentPeriodontiumRecord: data,
    });
  } else {
    const record: any = { ...(params?.data || {}) }
    const invert = record.invert;

    if (record.invert?.length === 1) {
      data.data[invert[0]] = record[`tmp_${invert[0]}`]
    } else if (record.invert?.length === 2) {
      data.data.plaque = record.tmp_plaque;
      data.data.bleeding = record.tmp_bleeding;
      data.tmp_plaque = record.data.plaque;
      data.tmp_bleeding = record.data.bleeding;
    }

    controller.setState({
      isMainLoading: false,
      periodontiumRecord: {
        ...data,
        editing_plaque: !!invert && ((invert.length === 1 && invert[0] === "bleeding") || !record.editing_plaque) ? false : true,
        editing_bleeding: !!invert && ((invert.length === 1 && invert[0] === "plaque") || !record.editing_bleeding) ? false : true
      },
      encounterInfo: {
        ...state.encounterInfo,
        plaque: data?.data?.plaque || [],
        bleeding: data?.data?.bleeding || [],
      },
    });
  }
};

// SAVE Periodontal Screening and Recording
export const handleChangePeriodontiumRecordData: Handler = (controller, params) => {
  const state = controller.getState();

  let data = { ...state.periodontiumRecord };
  data.data[params.name] = params.value;

  controller.setState({ periodontiumRecord: data });
};

export const handleSavePeriodontiumRecordData: Handler = async (controller, params) => {
  const state = controller.getState();

  await controller.setState({
    periodontiumRecord: {
      ...state.periodontiumRecord,
      editing_psr: params?.data?.editing_psr
    }
  });

  let data = { ...state.periodontiumRecord };
  if (state.periodontiumRecord?.id) {
    data.pk = state.periodontiumRecord.id;
  }

  handleSavePeriodontiumRecord(controller, params?.data ? { ...params.data, pk: state.periodontiumRecord.id } : data);
};

export const RecalPlaqueBleed: Handler = async (controller, params) => {
  const state = controller.getState();
  // let missingTeeth = state.patientDetail?.missingteeth.map((item) => item.primary);
  // console.log("RecalPlaqueBleed missingTeeth", missingTeeth);
  // let partialmissingTeeth = state.patientDetail?.partialmissingteeth.map((item) => item.primary);
  // console.log("RecalPlaqueBleed partialmissingTeeth", partialmissingTeeth);
  // let totalmissing = [...missingTeeth, ...partialmissingTeeth];
  // totalmissing = [...new Set(totalmissing)];

  let plaque = state.periodontiumRecord?.data?.plaque ? [...state.periodontiumRecord.data.plaque] : [];
  let bleeding = state.periodontiumRecord?.data?.bleeding ? [...state.periodontiumRecord.data.bleeding] : [];

  const plaqueIndex = controller.handleEvent({ message: "CalculatePlaqueIndex", params: plaque });
  const bleedingIndex = controller.handleEvent({ message: "CalculateBleedingIndex", params: bleeding });

  let data = {
    encounter: state.encounterInfo.id,
    plaque_index: plaqueIndex,
    bleeding_index: bleedingIndex,
    data: {
      ...state.periodontiumRecord?.data,
    },
  };
  if (state.periodontiumRecord?.id) {
    data.pk = state.periodontiumRecord.id;
    data.encounter = state.periodontiumRecord.encounter;
  }
  handleSavePeriodontiumRecord(controller, data);
};

export const CalculatePlaqueIndex: Handler = (controller, params = []) => {
  const state = controller.getState()
  let missingTeeth = (state.patientDetail?.missingteeth || []).map((item: any) => item.primary);
  let partialmissingTeeth: any[] = [] //state.patientDetail?.partialmissingteeth.map((item: any) => item.primary);
  let totalmissing = [...missingTeeth, ...partialmissingTeeth];
  totalmissing = [...new Set(totalmissing)];

  return ((params.length / (128 - totalmissing.length * 4)) * 100.0 || 0).toFixed(2);
}

export const CalculateBleedingIndex: Handler = (controller, params = []) => {
  const state = controller.getState()
  let missingTeeth = (state.patientDetail?.missingteeth || []).map((item: any) => item.primary);
  let partialmissingTeeth: any[] = [] //state.patientDetail?.partialmissingteeth.map((item: any) => item.primary);
  let totalmissing = [...missingTeeth, ...partialmissingTeeth];
  totalmissing = [...new Set(totalmissing)];

  return ((params.length / (192 - totalmissing.length * 6)) * 100.0 || 0).toFixed(2);
}

// SAVE Plaque, Bleeding
export const SetPlaque: Handler = async (controller, params) => {
  // controller.setState({ isMainLoading: true });

  const state = controller.getState();



  let plaque = state.periodontiumRecord?.data?.plaque ? [...state.periodontiumRecord.data.plaque] : [];
  let tmpPlaque = state.periodontiumRecord?.tmp_plaque ? [...state.periodontiumRecord.tmp_plaque] : [];

  const index = plaque.indexOf(params.key);

  if (index > -1) {
    plaque.splice(index, 1);
  } else {
    plaque.push(params.key);
  }

  // console.log(" state.patientDetail?.missingteeth.length plaque ", plaque)
  // console.log(" state.patientDetail?.missingteeth.length ", state.patientDetail?.missingteeth.length)
  // console.log(" state.patientDetail?.partialmissingteeth.length ", state.patientDetail?.partialmissingteeth.length)
  // console.log(" totalmissing.length ", totalmissing.length)
  const plaqueIndex = controller.handleEvent({ message: "CalculatePlaqueIndex", params: tmpPlaque });

  let data = {
    ...state.periodontiumRecord,
    encounter: state.encounterInfo.id,
    plaque_index: plaqueIndex,
    bleeding_index: state.periodontiumRecord?.bleeding_index || "0.00",
    data: {
      ...state.periodontiumRecord?.data,
      plaque: plaque,
    },
    editing_plaque: true
  };
  if (state.periodontiumRecord?.id) {
    data.pk = state.periodontiumRecord.id;
    data.encounter = state.periodontiumRecord.encounter;
  }

  controller.setState({
    periodontiumRecord: data,
    encounterInfo: {
      ...state.encounterInfo,
      plaque: data?.data?.plaque || [],
      bleeding: data?.data?.bleeding || [],
    },
  })

  // handleSavePeriodontiumRecord(controller, data);
};

export const SetBleeding: Handler = async (controller, params) => {
  // controller.setState({ isMainLoading: true });

  const state = controller.getState();
  let missingTeeth = state.patientDetail?.missingteeth.map((item) => item.primary);
  let partialmissingTeeth = state.patientDetail?.partialmissingteeth.map((item) => item.primary);
  let totalmissing = [...missingTeeth, ...partialmissingTeeth];
  totalmissing = [...new Set(totalmissing)];

  let bleeding = state.periodontiumRecord?.data?.bleeding ? [...state.periodontiumRecord.data.bleeding] : [];
  let tmpBleeding = state.periodontiumRecord?.tmp_bleeding ? [...state.periodontiumRecord.tmp_bleeding] : [];

  const index = bleeding.indexOf(params.key);
  if (index > -1) {
    bleeding.splice(index, 1);
  } else {
    bleeding.push(params.key);
  }

  const bleedingIndex = controller.handleEvent({ message: "CalculateBleedingIndex", params: tmpBleeding })

  let data = {
    ...state.periodontiumRecord,
    encounter: state.encounterInfo.id,
    plaque_index: state.periodontiumRecord?.plaque_index || "0.00",
    bleeding_index: bleedingIndex,
    data: {
      ...state.periodontiumRecord?.data,
      bleeding: bleeding,
    },
    editing_bleeding: true
  };
  if (state.periodontiumRecord?.id) {
    data.pk = state.periodontiumRecord.id;
    data.encounter = state.periodontiumRecord.encounter;
  }

  controller.setState({
    periodontiumRecord: data,
    encounterInfo: {
      ...state.encounterInfo,
      plaque: data?.data?.plaque || [],
      bleeding: data?.data?.bleeding || [],
    },
  })
  // handleSavePeriodontiumRecord(controller, data);
};

export const handleSavePeriodontiumRecord: Handler = async (controller, data) => {
  let error = true;

  if (data.pk) {
    error = await UpdatePeriodontiumRecord(controller, data);
  } else {
    error = await CreatePeriodontiumRecord(controller, data);
  }

  if (error) {
    controller.setState({ isMainLoading: false, openModMessage: true, messageTitle: "บันทึกไม่สำเร็จ", errorMessage: error });
  } else {
    GetPeriodontium(controller, { data });
  }
};

// History
export const handleGetPeriodontiumHistory: Handler = async (controller) => {
  controller.setState({ isMainLoading: true });

  const state = controller.getState();

  const params = { patient: state.patientDetail.id };
  const response = await GetPeriodontiumRecord(controller, params);

  controller.setState({ isMainLoading: false, periodontiumHistoryList: response });
};

// Examination
export const SetCheckedPeriodontalExam: Handler = (controller, params) => {
  const state = controller.getState();

  let data = { ...state.periodontalExamData };

  const resetData = (prefix: string) => {
    [1, 2, 3, 4].forEach((number) => {
      const obj = data.data[`${prefix}${number}`]
      if (obj?.text) {
        data.data[`${prefix}${number}`].value = false
      }
    })
  }

  if (params.name.includes("plaqueStain")) {
    resetData("plaqueStain")
  }

  if (params.name.includes("calculus")) {
    resetData("calculus")
  }

  data.data[params.name] = { value: params.value, text: params.text };

  controller.setState({ periodontalExamData: data });
};

export const handleGetPeriodontalExam: Handler = async (controller) => {
  controller.setState({ isMainLoading: true });

  const state = controller.getState();

  const params = { tissue_name: TISSUE_NAME, encounter: state.encounterInfo.id };
  const response = await GetExaminationForm(controller, params);

  controller.setState({ isMainLoading: false, periodontalExamData: response });
};

export const handleSavePeriodontalExam: Handler = async (controller) => {
  controller.setState({ isMainLoading: true });

  const state = controller.getState();

  let error = true;
  const data = {
    tissue_name: TISSUE_NAME,
    encounter: state.encounterInfo.id,
    data: state.periodontalExamData.data,
  };

  if (state.periodontalExamData?.id) {
    data.pk = state.periodontalExamData.id;
    data.encounter = state.periodontalExamData.encounter;
    data.tissue = state.periodontalExamData.tissue;
    error = await UpdateExaminationForm(controller, data);
  } else {
    error = await CreateExaminationForm(controller, data);
  }

  if (error) {
    controller.setState({ isMainLoading: false, openModMessage: true, messageTitle: "บันทึกไม่สำเร็จ", errorMessage: error });
  } else {
    controller.setState({ isMainLoading: false, openModMessage: true, messageTitle: "บันทึกสำเร็จ", errorMessage: null });
  }
};

// -------------------- APIs
const GetMissingTooth: Handler = async (controller, params) => {
  const [response, error, network] = await PatientSupernumeraryToothList.list({
    apiToken: controller.apiToken,
    params: params,
  });
  if (error) {
    return [];
  } else {
    return response.items;
  }
};
// Periodontium Record
const GetPeriodontiumRecord: Handler = async (controller, params) => {
  if(params?.encounter && !Number.isFinite(params.encounter)){
    return [];
  }

  const [response, error, network] = await PeriodontiumRecordList.list({
    apiToken: controller.apiToken,
    params: params,
  });
  if (error) {
    return [];
  } else {
    return response.items;
  }
};

const CreatePeriodontiumRecord: Handler = async (controller, data) => {
  const [response, error, network] = await PeriodontiumRecordList.create({
    apiToken: controller.apiToken,
    data: data,
  });
  if (error) {
    return error;
  } else {
    return false;
  }
};

const UpdatePeriodontiumRecord: Handler = async (controller, data) => {
  const [response, error, network] = await PeriodontiumRecordDetail.update({
    apiToken: controller.apiToken,
    pk: data.pk,
    data: data,
  });
  if (error) {
    return error;
  } else {
    return false;
  }
};

// Examination
const GetExaminationForm: Handler = async (controller, params) => {
  const [response, error, network] = await DentalExaminationFormList.list({
    apiToken: controller.apiToken,
    params: params,
  });
  if (error) {
    return { data: {} };
  } else {
    if (response.items.length > 0) {
      const result = { ...response.items[0] };
      result.data = JSON.parse(response.items[0].data).data;
      return result;
    }
    return { data: {} };
  }
};

const CreateExaminationForm: Handler = async (controller, data) => {
  const [response, error, network] = await DentalExaminationFormList.create({
    apiToken: controller.apiToken,
    data: data,
  });
  if (error) {
    return error;
  } else {
    return false;
  }
};

const UpdateExaminationForm: Handler = async (controller, data) => {
  const [response, error, network] = await DentalExaminationFormDetail.update({
    apiToken: controller.apiToken,
    pk: data.pk,
    data: data,
  });
  if (error) {
    return error;
  } else {
    return false;
  }
};
